/**
 * USER-RECAP-TOOLTIP
 * Info icon : the summary of a collaborator (what is filled, what is missing) on hover
 */
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"
import Tooltip from "@/components/tooltip"
import { getUserRecapLines } from "@/utils/user-recap.utils"

interface OwnProps {
  user: any
}

export default function UserRecapTooltip(props: OwnProps) {
  const { t } = useTranslation()
  const lines = getUserRecapLines(props.user, {
    firstname: t("user_firstname"),
    lastname: t("user_lastname"),
    email: t("user_email"),
    phone: t("user_phone"),
    address: t("user_address"),
    language: t("user_language"),
    missing: "-"
  })

  return (
    <Tooltip text={lines} position="top" usePortal>
      <FontAwesomeIcon icon={faInfoCircle} className="grey-t" style={{ marginRight: 12 }} />
    </Tooltip>
  )
}
